import { SITE_PAGE_PUBLISH_STATES } from "replo-utils/lib/sitePages";
import { z } from "zod";

export const sitePagePublishStateSchema = z
  .enum(SITE_PAGE_PUBLISH_STATES)
  .describe("SitePagePublishState");

export const sandboxFileSchema = z
  .object({
    appName: z.string(),
    filepath: z.string(),
    route: z.string(),
    modifiedAt: z.number().optional(),
    // Birth-time (epoch ms) from `stat`, falling back to mtime when the
    // filesystem reports 0/unsupported. Used to sort the pages dashboard.
    createdAt: z.number().optional(),
    // Set by findSitePages; absent from raw findFiles results.
    publishState: sitePagePublishStateSchema.optional(),
  })
  .describe("SandboxFile");

export const workspaceSkillSourceSchema = z
  .enum(["builtin", "project"])
  .describe("WorkspaceSkillSource");

export const workspaceSkillSchema = z
  .object({
    slug: z.string(),
    source: workspaceSkillSourceSchema,
    filepath: z.string().optional(),
    name: z.string(),
    description: z.string(),
    body: z.string(),
    tagline: z.string().optional(),
    category: z.string().optional(),
    tags: z.array(z.string()),
    imageUrl: z.string().optional(),
    shape: z.string().optional(),
    gradient: z.string().optional(),
    modifiedAt: z.number().optional(),
  })
  .describe("WorkspaceSkill");

export const skillFileSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    description: z.string(),
    body: z.string(),
  })
  .describe("SkillFile");
